import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@reenstudio/app/core/services/auth.service';
import { StorageService } from '../services/storage.service';
import { SnackbarService } from '@reenstudio/app/shared/services/snackbar/snackbar.service';
import { AppService } from '../services/app.service';
import { CustomNGXLoggerService, NGXLogger, NgxLoggerLevel } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private logger: NGXLogger;

  constructor(
    private authService: AuthService,
    private localStorage: StorageService,
    private snackBar: SnackbarService,
    private appService: AppService,
    private customLogger: CustomNGXLoggerService,
    private router: Router
  ) {
    this.logger = customLogger.create({ level: NgxLoggerLevel.DEBUG });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> | boolean {
    // TODO
    // IMPLEMENTARE CONTROLLO ACCESSI IN BASE AL LIVELLO UTENTE

    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      if (this.localStorage.getToken()?.length) {
        // this.appService.reload();
        // this.logger.debug(
        //   'Auth Guard. Sessione scaduta. Refresh Token in corso'
        // );
        // this.snackBar.warning(
        //   'Auth Guard. Sessione scaduta. Refresh Token in corso'
        // );
        return true;
      } else {
        // this.logger.debug(
        //   "Auth Guard. Sessione scaduta. Eseguire nuovamente l'accesso"
        // );
        // this.snackBar.warning(
        //   "Sessione scaduta. Eseguire nuovamente l'accesso"
        // );
        // this.router.navigate(['/dashboard']);
        this.authService.signOut();
        return false;
      }
    }
  }
}
